import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppResolver } from './app.resolver';
import { AuthGuard } from './core/guards/auth.guard';
import { LayoutContainerComponent } from './layout/layout-container.component';

const routes: Routes = [
  {
    path: "",
    component: LayoutContainerComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule),
        resolve: [
          AppResolver
        ]
      },
      {
        path: 'projects/:projectId',
        loadChildren: () => import('./pages/projects/projects.module').then(m => m.ProjectsModule)
      },
    ],
  },

  {
    path: "auth",
    loadChildren: () => import("./auth/auth.module").then((m) => m.AuthModule),
  },
  {
    path: '403',
    loadChildren: () => import('./pages/extra-pages/error403/error403.module').then(m => m.Error403Module)
  },
  {
    path: '404',
    loadChildren: () => import('./pages/extra-pages/error404/error404.module').then(m => m.Error404Module)
  },
  {
    path: '**',
    redirectTo: '/404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { anchorScrolling: "enabled" })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
